import actions from './actions';

const initState = {
    notification: {},
    notifications   : {
        data: []
    },
    notificationsHistory: {
        data: []
    },
    loading : false,
    acceptRejectNotification: false,
    message: null,
    type: null,
    status: null,
    fcmToken: null
};

export default function fetchNotificationsReducer(state = initState, action) {
    switch (action.type) {
        case actions.FETCH_NOTIFICATIONS_REQUESTED:
            return {
                ...state,
                notifications   : {
                    data: []
                },
                loading : true
            };
        case actions.FETCH_NOTIFICATIONS_SUCCEEDED:
            return {
                ...state,
                notifications    : action.notifications,
                loading     : false
            };
        case actions.FETCH_NOTIFICATIONS_FAILED:
            return {
                ...state,
                loading : false
            };
        case actions.PUSH_NOTIFICATIONS_REQUESTED:
            return {
                ...state,
                loading : true
            };
        case actions.PUSH_NOTIFICATIONS_SUCCEEDED:
            return {
                ...state,
                message: action.notifications?.message,
                status: action.notifications?.status,
                loading: false,
                type : "success"
            };
        case actions.PUSH_NOTIFICATIONS_FAILED:
            return {
                ...state,
                message    : action.error?.message,
                status: action.error?.status,
                loading: false,
                type : "success"
            };
        case action.SUBSCRIBE_NOTIFICATION_SUCCEEDED:
            return {
                ...state,
                fcmToken: action.fcmToken
            }
        case actions.FETCH_NOTIFICATIONS_HISTORY_REQUESTED:
            return {
                ...state,
                notificationsHistory: {
                    data: []
                },
                loading : true
            };
        case actions.FETCH_NOTIFICATIONS_HISTORY_SUCCEEDED:
            return {
                ...state,
                notificationsHistory: action.notifications,
                loading: false
            };
        case actions.FETCH_NOTIFICATIONS_HISTORY_FAILED:
            return {
                ...state,
                loading: false
            };
        default:
            return state;
    }
}
